import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import { isDataEmpty, SUPPLIER_STATUS } from 'features/supplier/utils';

import ModalContainer from '@components/modals/ModalContainer';
import { toastError, toastSuccess } from '@components/Toast';

import EditButton from '@features/supplier/component/EditButton';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchAllTags, fetchSupplierDetails } from '@store/supplier/action';

import { fetchEnumValues } from '@services/commonService';
import { getSupplierCategoryStrengths } from '@services/supplierOnboardingService';

import ApiClient from '@lib/apiClient';

import {
	capitalizeFirstLetter,
	getNumberUnit,
	replaceUnderLine,
	validateFloatNumber,
	validateNumber
} from '@utils/Util';

const QuickInfo = ({ detailsInfo }) => {
	const [isEdit, setIsEdit] = useState(false);
	const [supplierInfo, setSupplierInfo] = useState(detailsInfo);
	const [supplierInfoUpdatedData, setSupplierInfoUpdatedData] = useState(detailsInfo);
	const [errors] = useState(null);
	const [supplierList, setSupplierList] = useState([]);
	const [categoryList, setCategoryList] = useState([]);
	const [supplierStatus, setSupplierStatus] = useState([]);
	const [coreProductBase, setCoreProductBase] = useState([]);
	const [categoryStrength, setCategoryStrength] = useState([]);
	const dispatch = useDispatch();
	const { id } = useParams();
	const isLoading = useSelector((store) => store.loaderStore);
	const tagType = 'SUPPLIER_STRENGTH';
	const strngthType = 'SUPPLIER_ADDITIONAL_TAG';

	useEffect(() => {
		setSupplierInfo(detailsInfo);
		setSupplierInfoUpdatedData(detailsInfo);
	}, [detailsInfo]);

	const setSelectedSupplierCategories = (dataList) => {
		setCategoryList(dataList);
	};

	const handleShow = async () => {
		setIsEdit(true);
		await fetchEnumValues('info.nitex.app.supplier.SupplierType', setSupplierList);
		await fetchEnumValues('info.nitex.app.supplier.SupplierCategory', setSelectedSupplierCategories);
		await fetchEnumValues('info.nitex.app.supplier.SupplierStatus', setSupplierStatus);
		await fetchEnumValues('info.nitex.app.supplier.CoreProductBaseType', setCoreProductBase);
		const data = await getSupplierCategoryStrengths();
		setCategoryStrength(data);
		dispatch(fetchAllTags('', tagType));
		dispatch(fetchAllTags('', strngthType));
	};

	const onChangeInfo = (e) => {
		const { id, value } = e.target;
		setSupplierInfoUpdatedData({ ...supplierInfoUpdatedData, [id]: value });
	};

	const onPriceRangeClick = (selectedItems) => {
		let items = selectedItems.map((item) => item.id);
		setSupplierInfoUpdatedData({ ...supplierInfoUpdatedData, pricePointList: items });
	};

	const onChangeSupplierType = (selectedItems) => {
		let items = selectedItems.map((item) => item.id);
		setSupplierInfoUpdatedData({ ...supplierInfoUpdatedData, supplierTypeList: items });
	};

	const onChangeCategoryInfo = (selectedItems) => {
		let items = selectedItems.map((item) => item.id);
		setSupplierInfoUpdatedData({ ...supplierInfoUpdatedData, supplierCategoryList: items });
	};

	const onChangeCategoryStrength = (selectedItems) => {
		let items = selectedItems.map((item) => item.value);
		setSupplierInfoUpdatedData({ ...supplierInfoUpdatedData, productCategoryStrengthList: items });
	};

	const onChangeCoreProductBase = (selectedItems) => {
		let items = selectedItems.map((item) => item.value);
		setSupplierInfoUpdatedData({ ...supplierInfoUpdatedData, coreProductBaseTypeList: items });
	};

	const onSubmitData = async () => {
		const {
			supplierTypeList,
			supplierCategoryList,
			pricePointList,
			supplierStatus,
			annualTrunOver,
			totalEmployee,
			numberOfLine,
			lastAuditDate,
			contactPersonAndDesignation,
			phoneNumber,
			coreProductBaseTypeList,
			productCategoryStrengthList
		} = supplierInfoUpdatedData;

		const body = {
			isQuickInfoUpdate: true,
			supplierTypeList,
			supplierCategoryList,
			pricePointList,
			supplierStatus,
			annualTrunOver: annualTrunOver ? parseInt(annualTrunOver) : null,
			totalEmployee,
			numberOfLine,
			lastAuditDate,
			contactPersonAndDesignation,
			phoneNumber,
			coreProductBaseTypeList,
			productCategoryStrengthList: productCategoryStrengthList?.map(
				(item) => item.value || item.constant
			)
		};

		// const isValid = isValidForm(body);
		// if (!isValid) {
		// 	return;
		// }
		dispatch(openLoader());
		await ApiClient.PUT('updateSupplierInfo', body, id)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchSupplierDetails(id));
					setSupplierInfoUpdatedData(detailsInfo);
					setIsEdit(false);
				}
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	return (
		<div>
			<div className="capacity-section section-padding hover-section">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">
					QUICK INFO
					<EditButton onEditClick={handleShow} />
				</h3>
				<div className="info-items_bottom">
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Group Name</p>
						<h3 className="title regular-18 weight-500">
							{isDataEmpty(supplierInfo?.groupName)}
						</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Department</p>
						<h3 className="title regular-18 weight-500">
							{isDataEmpty(
								supplierInfo?.departmentList
									?.map((item) => capitalizeFirstLetter(item.name))
									.join(', ')
							)}
						</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Supplier Type</p>
						<h3 className="title regular-18 weight-500">
							{isDataEmpty(
								supplierInfo?.supplierTypeList
									?.map((item) => capitalizeFirstLetter(item))
									.join(', ')
							)}{' '}
						</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Category</p>
						<h3 className="title regular-18 weight-500">
							{' '}
							{isDataEmpty(
								supplierInfo?.supplierCategoryList
									?.map((item) => replaceUnderLine(item))
									.join(', ')
							)}
						</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Price Range</p>
						<h3 className="title regular-18 weight-500">
							{isDataEmpty(supplierInfo?.pricePointList?.join(', '))}
						</h3>
					</div>
				</div>
				<div className="info-items_bottom mt-3">
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Contact</p>
						{supplierInfo?.contactPersonAndDesignation || supplierInfo?.phoneNumber ? (
							<>
								<h3 className="title regular-18 weight-500">
									{supplierInfo?.contactPersonAndDesignation}
								</h3>
								<p className="gray_dark_02 regular-14">{supplierInfo?.phoneNumber}</p>
							</>
						) : (
							'--'
						)}
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Annual Turnover</p>
						<h3 className="title regular-18 weight-500">
							{supplierInfo?.annualTrunOver
								? '$' + getNumberUnit(supplierInfo?.annualTrunOver)
								: '--'}
						</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<div className="employee-info cursor-pointer d-flex">
							<p className="gray_dark_02 regular-14 mr-1">Total Employees</p>
							<img src={`${process.env.PUBLIC_URL}/icons/info.svg`} width={18} />
							<div className="employee-box shadow-8dp">
								<div className="d-flex justify-content-between mb-2">
									<p className="regular-12 gray_dark_02">Male</p>
									<p className="regular-12 gray_dark_02">
										{supplierInfo?.productionCapacity?.maleEmployeePercentage}%
									</p>
								</div>
								<div className="d-flex justify-content-between">
									<p className="regular-12 gray_dark_02">Female</p>
									<p className="regular-12 gray_dark_02">
										{supplierInfo?.productionCapacity?.femaleEmployeePercentage}%
									</p>
								</div>
							</div>
						</div>

						<h3 className="title regular-18 weight-500">
							{supplierInfo?.totalEmployee ? supplierInfo?.totalEmployee : '--'}
						</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Production Line</p>
						<h3 className="title regular-18 weight-500">
							{' '}
							{supplierInfo?.numberOfLine ? supplierInfo?.numberOfLine : '--'}
						</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Supplier status</p>
						{supplierInfo?.supplierStatus ? (
							<div>
								<span
									className={`status d-inline ${
										SUPPLIER_STATUS[supplierInfo?.supplierStatus]
									}`}
								>
									{replaceUnderLine(supplierInfo?.supplierStatus)}
								</span>
							</div>
						) : (
							'--'
						)}
					</div>
				</div>
				<div className="info-items_bottom mt-3">
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">
							Last Audit
							{!supplierInfo?.isVisited && (
								<span className="status red-3 ml-1">Audit Pending</span>
							)}
						</p>

						<h3 className="title regular-18 weight-500">{supplierInfo?.lastAuditDate}</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Core Product Base</p>
						<h3 className="title regular-18 weight-500">
							{isDataEmpty(
								supplierInfo?.coreProductBaseTypeList
									?.map((item) => capitalizeFirstLetter(item))
									.join(', ')
							)}
						</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Product Category Strength</p>
						<h3 className="title regular-18 weight-500">
							{isDataEmpty(
								supplierInfo?.productCategoryStrengthList
									?.map((item) => capitalizeFirstLetter(item.name))
									.join(', ')
							)}
						</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Establishment Year</p>
						<h3 className="title regular-18 weight-500">
							{isDataEmpty(supplierInfo?.establishmentYear?.toString())}
						</h3>
					</div>
				</div>
			</div>

			{isEdit && (
				<ModalContainer>
					<div className="common-popup filter-quick-search-modal quick-info-modal">
						<div className="common-popup-header d-flex justify-content-between">
							<div className="popup-tilte">
								<h3 className="semibold-16 mb-0">Quick Info</h3>
							</div>
							<div className="close-btn" onClick={() => setIsEdit(false)}>
								<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
							</div>
						</div>

						<div className="common-popup-body scroll-y-label">
							<div className="container px-0">
								<div className="row">
									<div className="col-md-6">
										<div className="form-group no-shadow-react-select size36">
											<label htmlFor="supplierType">Supplier type</label>
											<Select
												onChange={onChangeSupplierType}
												defaultValue={supplierInfoUpdatedData?.supplierTypeList?.map(
													(item) => ({
														id: item,
														text: item,
														value: item,
														label: item
													})
												)}
												isMulti
												isDisabled={false}
												options={supplierList}
											/>
											{errors?.typeError && (
												<p className="error">{errors?.typeError}</p>
											)}
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group no-shadow-react-select size36">
											<label htmlFor="category">Category</label>
											<Select
												onChange={onChangeCategoryInfo}
												defaultValue={supplierInfoUpdatedData?.supplierCategoryList?.map(
													(item) => ({
														id: item,
														text: item,
														value: item,
														label: item
													})
												)}
												isMulti
												options={categoryList}
											/>
											{errors?.categoryError && (
												<p className="error">{errors?.categoryError}</p>
											)}
										</div>
									</div>

									<div className="col-md-6">
										<div className="form-group no-shadow-react-select size36">
											<label htmlFor="supplierType">Core Product Base</label>
											<Select
												onChange={onChangeCoreProductBase}
												defaultValue={supplierInfoUpdatedData?.coreProductBaseTypeList?.map(
													(item) => ({
														value: item,
														label: capitalizeFirstLetter(item)
													})
												)}
												isMulti
												isDisabled={false}
												options={coreProductBase}
											/>
											{errors?.coreProductBaseError && (
												<p className="error">{errors?.coreProductBaseError}</p>
											)}
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group no-shadow-react-select size36">
											<label htmlFor="category">Product Category Strength</label>
											<Select
												onChange={onChangeCategoryStrength}
												defaultValue={supplierInfoUpdatedData?.productCategoryStrengthList?.map(
													(item) => ({
														value: item.constant,
														label: item.name
													})
												)}
												isMulti
												options={categoryStrength}
											/>
											{errors?.productCategoryStrengthError && (
												<p className="error">
													{errors?.productCategoryStrengthError}
												</p>
											)}
										</div>
									</div>

									<div className="col-md-4 pr-2">
										<div className="form-group">
											<label htmlFor="annualTrunOver">Annual turnover</label>
											<input
												type="number"
												onKeyDown={validateFloatNumber}
												className="w-100"
												id="annualTrunOver"
												value={supplierInfoUpdatedData?.annualTrunOver}
												onChange={(e) => onChangeInfo(e)}
											/>
										</div>
									</div>
									<div className="col-md-4 pr-2">
										<div className="form-group">
											<label htmlFor="totalEmployee">Total employees</label>
											<input
												type="number"
												onKeyDown={validateFloatNumber}
												className="w-100"
												id="totalEmployee"
												value={supplierInfoUpdatedData?.totalEmployee}
												onChange={(e) => onChangeInfo(e)}
											/>
										</div>
									</div>
									<div className="col-md-4 pr-2">
										<div className="form-group no-shadow-react-select size36">
											<label htmlFor="priceRange">Price range</label>
											<Select
												onChange={onPriceRangeClick}
												defaultValue={supplierInfoUpdatedData?.pricePointList?.map(
													(item) => ({
														id: item,
														text: item,
														value: item,
														label: item
													})
												)}
												isMulti
												isDisabled={false}
												options={[
													{
														id: 'LOW',
														text: 'LOW',
														value: 'LOW',
														label: 'Low'
													},
													{
														id: 'MID',
														text: 'MID',
														value: 'MID',
														label: 'Mid'
													},
													{
														id: 'HIGH',
														text: 'HIGH',
														value: 'HIGH',
														label: 'High'
													}
												]}
											/>
										</div>
									</div>

									<div className="col-md-4 pr-2">
										<div className="form-group">
											<label htmlFor="numberOfLine">Production line</label>
											<input
												type="number"
												onKeyDown={validateNumber}
												className="w-100"
												id="numberOfLine"
												value={supplierInfoUpdatedData?.numberOfLine}
												onChange={(e) => onChangeInfo(e)}
											/>
										</div>
									</div>
									<div className="col-md-4 pr-2">
										<label htmlFor="supplierStatus">Supplier Status</label>
										<select
											className="w-100"
											name="supplierStatus"
											id="supplierStatus"
											value={supplierInfoUpdatedData?.supplierStatus}
											onChange={(e) => onChangeInfo(e)}
										>
											<option value={null}>Select</option>
											{supplierStatus.map((item) => (
												<option value={item.id} key={item.id}>
													{item.text}
												</option>
											))}
										</select>
									</div>
									<div className="col-md-4 pr-2">
										<div className="form-group">
											<label htmlFor="lastAuditDate">Last Audit</label>
											<input
												type="date"
												className="w-100"
												id="lastAuditDate"
												max={new Date().toISOString().split('T')[0]}
												value={supplierInfoUpdatedData?.lastAuditDate}
												onChange={(e) => onChangeInfo(e)}
											/>
										</div>
									</div>

									<div className="col-md-12">
										<div className="popup-tilte mb-2">
											<h3 className="semibold-16 mb-0">Contact</h3>
										</div>
									</div>
									<div className="col-md-12 pr-2">
										<div className="form-group">
											<label htmlFor="contactPersonAndDesignation">
												Contact person &amp; Designation
											</label>
											<input
												type="text"
												autoComplete="off"
												className="w-100"
												id="contactPersonAndDesignation"
												value={supplierInfoUpdatedData?.contactPersonAndDesignation}
												onChange={(e) => onChangeInfo(e)}
											/>
											{errors?.contactError && (
												<p className="error">{errors?.contactError}</p>
											)}
										</div>
									</div>
									<div className="col-md-12 pr-2">
										<div className="form-group">
											<label htmlFor="phoneNumber">Phone number</label>
											<input
												type="number"
												className="w-100"
												id="phoneNumber"
												value={supplierInfoUpdatedData?.phoneNumber}
												onKeyDown={validateNumber}
												onChange={(e) => onChangeInfo(e)}
											/>
											{errors?.phoneNumberError && (
												<p className="error">{errors?.phoneNumberError}</p>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<div className="footer-buttons text-right">
								<button
									className="button gray-outline size32"
									onClick={() => {
										setSupplierInfoUpdatedData(detailsInfo);
										setIsEdit(false);
									}}
								>
									Cancel
								</button>
								<button
									className="button size32 ml-2"
									disabled={isLoading}
									onClick={() => onSubmitData()}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</ModalContainer>
			)}
		</div>
	);
};

export default QuickInfo;
